import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import actionTypes from "../../../../store/actions";
import {
  Grid,
  Card,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Typography,
  FormHelperText,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  Divider,
  MenuItem,
} from "@mui/material";
import Draggable from "react-draggable";
import { Paper } from "@mui/material";
import Button from "../../../../component/button";
import Input from "../../../../component/inputpm";
import Pagination from "@mui/material/Pagination";
import Tooltip from "@mui/material/Tooltip";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  EditIconNew,
  OpenItemIcon,
  EndItemIcon,
  ExpandAll,
} from "../../../../component/icons/icons";
import CloseIcon from "@mui/icons-material/Close";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view/TreeItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import BusApiCall from "../../../../helper/axios";
import constants from "../../../../helper/constants";
import Loader from "../../../../component/loader";
import classes from "../../component/component.module.css";
import "../../component/specification/productSpecification.css";
import {
  toApi,
  fromApi,
  normalizeDateTime,
} from "../../component/specification/characteristicMapper";
import { formatNumber } from "../../../../helper/numberFormatter";

class EditSpecCharacteristicsAppl extends Component {
  constructor(props) {
    super(props);
    this.initialState = {
      showLoading: false,
      showSpecLoading: false,
      productSpecifications: props.productSpecifications || [],
      childData: {},
      expandedNodes: [],
      allExpanded: false,
      rowsPerPage: 20,
      page: 1,
      startRecord: 1,
      totalCount: 0,
      specificationSearchString: "",
      specificationSearchCategory: "PSC_PROD",
      selectedSpecificationId: "",
      selectedSpecificationDescription: "",
      specCategoryList: props.specCategoryList || [],

      productCharacteristics: [],
      rowsPerPageCharacteristics: 20,
      pageCharacteristics: 1,
      startRecordCharacteristics: 1,
      totalCharacteristicsCount: 0,
      characteristicId: "",
      characteristicDescription: "",
      name: "",

      filteredProductCharacteristics: [],

      selectedProductId: "",
      selectedCharacteristics: [],
      errors: {},
      formDataAddSpec: {},
      existingProductSpecification: false,

      //
      allUpdatedCharacteristics: [],
      isClicked: false,
    };
    this.state = { ...this.initialState };
  }

  handleAssignAllOld = () => {
    const errors = {};
    this.setState({ isClicked: true });
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const pathArray = this.state.selectedSpecificationPath
      ? this.state.selectedSpecificationPath.split("-")
      : [];
    const rootSpecificationId =
      pathArray.length > 0
        ? pathArray[0]
        : this.state.selectedSpecificationPath;

    const formData = {
      productId: this.state.selectedProductId,
      specId: rootSpecificationId
        ? rootSpecificationId
        : this.state.selectedSpecificationId,
      productSpecCharacteristic: this.state.allUpdatedCharacteristics.map(
        (char) => {
          const {
            name,
            description,
            productId,
            characteristicTypeId,
            ...cleanedChar
          } = char;
          return {
            ...cleanedChar,
          };
        },
      ),
    };

    if (this.props.storeApplData) {
      this.props.storeApplData(formData);
    }
  };

  handleUnassignAllOld = () => {
    const { productId } = this.props;
    this.setState({ isClicked: true });
    const unassignData = {
      productId,
      action: "DELETE",
    };

    if (this.props.storeApplData) {
      this.props.storeApplData(unassignData);
    }
  };

  handleAssignAll = (action) => {
    const errors = {};
    if (Object.keys(errors).length > 0) {
      this.setState({ errors: errors });
      return;
    }

    const pathArray = this.state.selectedSpecificationPath
      ? this.state.selectedSpecificationPath.split("-")
      : [];
    const rootSpecificationId =
      pathArray.length > 0
        ? pathArray[0]
        : this.state.selectedSpecificationPath;

    var transformPayload = this.state.allUpdatedCharacteristics.map(toApi);
    const formData = {
      productId: this.state.selectedProductId,
      specId: rootSpecificationId
        ? rootSpecificationId
        : this.state.selectedSpecificationId,
      productSpecCharacteristic: transformPayload.map((char) => {
        const {
          name,
          description,
          productId,
          characteristicTypeId,
          ...cleanedChar
        } = char;
        return {
          ...cleanedChar,
          action: action,
        };
      }),
    };
    //console.log("-------------formData--------------",formData);
    if (!this.state.selectedProductId) {
      if (this.props.storeApplData) {
        this.props.storeApplData(formData);
      }
      this.setState({ existingProductSpecification: true });
      return true;
    }
    this.setState({ showLoading: true, showSpecLoading: true });
    BusApiCall(
      "POST",
      `${constants.busV44UrlPublic}/productSpecificationAppl`,
      formData,
    )
      .then((res) => {
        //this.setState({showLoading: false, showSpecLoading: false})
        if (this.props.showSaveCharacteristicMessage) {
          this.props.showSaveCharacteristicMessage(false);
        }
        this.getFeatureApplList();
        if (this.props.showResponseMessage) {
          this.props.showResponseMessage(
            action === "edit"
              ? this.props.t("SPECIFICATION_APPL_UPDATE_SUCCESSFULLY")
              : this.props.t("SPECIFICATION_APPL_ASSIGN_SUCCESSFULLY"),
            "success",
          );
        } else {
          this.props.setErrorMessage(
            action === "edit"
              ? this.props.t("SPECIFICATION_APPL_UPDATE_SUCCESSFULLY")
              : this.props.t("SPECIFICATION_APPL_ASSIGN_SUCCESSFULLY"),
            true,
          );
        }
      })
      .catch((err) => {
        this.setState({ showLoading: false, showSpecLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(err.response.data.message, "error");
          } else {
            this.props.setErrorMessage(err.response.data.message, false);
          }
        } else {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              "error",
            );
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        }
        console.error("Error creating product spec appl:", err);
      });
  };

  handleUnassignAll = () => {
    //console.log("-------------this.state.selectedProductId--------------",this.state.selectedProductId);
    if (!this.state.selectedProductId) {
      if (this.props.storeApplData) {
        this.props.storeApplData({});
      }
      this.setState({ existingProductSpecification: false });
      return true;
    }

    this.setState({ showLoading: true, showSpecLoading: true });
    const { productId } = this.props;
    BusApiCall(
      "DELETE",
      `${constants.busV44UrlPublic}/productSpecificationAppl/${productId}`,
    )
      .then((res) => {
        //this.setState({showLoading: false, showSpecLoading: false})
        if (this.props.showResponseMessage) {
          this.props.showResponseMessage(
            this.props.t("SPECIFICATION_APPL_UNASSIGN_SUCCESSFULLY"),
            "success",
          );
        } else {
          this.props.setErrorMessage(
            this.props.t("SPECIFICATION_APPL_UNASSIGN_SUCCESSFULLY"),
            true,
          );
        }
        this.getSpecificationListAgain();
      })
      .catch((err) => {
        this.setState({ showLoading: false, showSpecLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(err.response.data.message, "error");
          } else {
            this.props.setErrorMessage(err.response.data.message, false);
          }
        } else {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              "error",
            );
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        }
        console.error("Error deleting product spec appl: ", err);
      });
  };

  getSpecificationListAgain = () => {
    this.setState({
      existingProductSpecification: false,
      selectedSpecificationId: "",
      rootSpecificationId: "",
    });
    this.getSpecificationList();
  };

  handleChangeAddSpec = (event, id, specId, rowType, rowFormat) => {
    const { name, value } = event.target;
    this.setState((prevState) => {
      let updatedErrors = { ...prevState.errors };
      let updatedAllCharacteristics = [...prevState.allUpdatedCharacteristics];

      const existingData = prevState.formDataAddSpec[`${specId}_${id}`] || {};
      //let format = name === 'format' ? value : (existingData.format || '');
      let format =
        name === "format"
          ? value
          : existingData.format !== undefined
            ? existingData.format
            : rowFormat || "";

      let isValid = true;
      let validatedValue = value;

      if (
        name === "value" &&
        (rowType?.toUpperCase() === "ENUMERATION" ||
          rowType?.toUpperCase() === "ENUM")
      ) {
        isValid = this.validateFormat(value, format);
        if (!isValid) {
          validatedValue = "-";
          updatedErrors[`${specId}_${id}`] =
            `Invalid value. Allowed: ${format.replace(/\|/g, ", ")}`;
        } else {
          delete updatedErrors[`${specId}_${id}`];
        }
      }

      const updatedFormData = {
        ...existingData,
        [name]: validatedValue,
        format: name === "format" ? value : format,
      };

      const updatedCharacteristic = {
        specId,
        id,
        value: updatedFormData.value || "",
        format: updatedFormData.format || "",
      };

      const key = `${specId}_${id}`;
      const existingIndex = updatedAllCharacteristics.findIndex(
        (char) => char.id === id && char.specId === specId,
      );
      //if ((updatedFormData.value || '').trim()  && updatedFormData.value !== '-' && isValid) {
      //Allow empty value to store in product spec appl
      if (updatedFormData.value !== "-" && isValid) {
        if (existingIndex !== -1) {
          updatedAllCharacteristics[existingIndex] = updatedCharacteristic;
        } else {
          updatedAllCharacteristics.push(updatedCharacteristic);
        }
      } else {
        updatedAllCharacteristics = updatedAllCharacteristics.filter(
          (char) => !(char.id === id && char.specId === specId),
        );
      }

      return {
        formDataAddSpec: {
          ...prevState.formDataAddSpec,
          [key]: updatedFormData,
        },
        allUpdatedCharacteristics: updatedAllCharacteristics,
        errors: updatedErrors,
      };
    });
    if (this.props.showSaveCharacteristicMessage) {
      this.props.showSaveCharacteristicMessage(true);
    }
  };

  getFeatureApplList = () => {
    this.setState({ showLoading: true, showSpecLoading: true });
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecificationAppl/${this.state.selectedProductId}`,
      "",
    )
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.specId) {
          let formData = {};
          const productSpecCharacteristic =
            res.data.productSpecCharacteristic.map(fromApi);
          let updatedCharacteristics = productSpecCharacteristic.map(
            (char) => ({
              ...char,
              productId: this.state.selectedProductId, // Add productId
            }),
          );

          // Populate formData with characteristic values
          updatedCharacteristics.forEach((char) => {
            let keyId = `${char.specId}_${char.id}`;
            formData[keyId] = char.value;
          });
          //console.log("===========updatedCharacteristics========",updatedCharacteristics)
          this.setState({
            existingProductSpecification: true,
            selectedCharacteristics: updatedCharacteristics,
            formDataAddSpec: formData,
            selectedSpecificationId: res.data.specId,
            selectedSpecificationDescription: res.data.specName
              ? res.data.specName
              : res.data.specDescription,
          });
          this.getSpecificSpecificationDetail(res.data.specId);
          //this.getSpecificationList();
        } else {
          this.getSpecificationList();
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false, showSpecLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(err.response.data.message, "error");
          } else {
            this.props.setErrorMessage(err.response.data.message, false);
          }
        } else {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              "error",
            );
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        }
      });
  };

  componentDidMount() {
    this.setState({ ...this.initialState });
    if (this.props.showSaveCharacteristicMessage) {
      this.props.showSaveCharacteristicMessage(false);
    }
    if (this.state.selectedProductId) {
      this.getFeatureApplList();
    } else {
      this.getSpecificationList();
    }
  }
  /*componentDidMount() {
        const { isDataFetched, setDataFetched } = this.props;

        if (!isDataFetched) {
          this.setState({ ...this.initialState });
          this.getFeatureApplList();
          setDataFetched(true); // tell parent we fetched once
        }
    }*/

  decodeHtml = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.documentElement.textContent;
  };
  getSpecificationList = () => {
    this.setState({
      showLoading: true,
      showSpecLoading: true,
      rootSpecificationId: "",
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };
    //console.log('===========this.state.existingProductSpecification====',this.state.existingProductSpecification)
    var url = `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC${this.state.selectedSpecificationId ? "&id=" + this.state.selectedSpecificationId : ""}`;
    if (
      this.state.specificationSearchString === "" &&
      this.state.specificationSearchCategory === "-"
    ) {
      url = `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC`;
    }
    if (
      !this.state.existingProductSpecification &&
      (this.state.specificationSearchString ||
        (this.state.specificationSearchCategory &&
          this.state.specificationSearchCategory !== "-"))
    ) {
      url = `${constants.busV44UrlPublic}/productSpecifications?sortBy=name&sortOrder=ASC${this.state.specificationSearchString ? "&name=" + this.state.specificationSearchString : ""}${this.state.specificationSearchCategory && this.state.specificationSearchCategory !== "-" ? "&category=" + this.state.specificationSearchCategory : ""}`;
    }
    BusApiCall("GET", url, "", pageOptions)
      .then((res) => {
        this.setState({ showLoading: false, showSpecLoading: false });
        if (res.data.length > 0) {
          this.setState({
            productSpecifications: res.data,
            totalCount: +res.headers["x-total-count"],
            selectedSpecificationId: res.data[0].id,
            selectedSpecificationDescription: res.data[0].name
              ? res.data[0].name
              : res.data[0].description,
            selectedSpecificationPath: res.data[0].id.toString(),
          });
          /*if(this.state.selectedSpecificationId){
                    this.handleExpand(this.state.selectedSpecificationId, this.state.selectedSpecificationDescription, [this.state.selectedSpecificationId]);
                }else{
                    this.getCharacteristicList();
                }*/
          this.getCharacteristicList();
        } else {
          this.setState({
            productSpecifications: [],
            totalCount: 0,
            selectedSpecificationId: "",
            selectedSpecificationDescription: "",
            selectedSpecificationPath: "",
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false, showSpecLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(err.response.data.message, "error");
          } else {
            this.props.setErrorMessage(err.response.data.message, false);
          }
        } else {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              "error",
            );
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        }
      });
  };

  getCharacteristicList = () => {
    this.setState({ showLoading: true });
    let pageOptions = {
      batchSize: this.state.rowsPerPageCharacteristics,
      startRecord: this.state.startRecordCharacteristics,
    };
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productCharacteristics?sortBy=name&sortOrder=ASC${this.state.name ? "&name=" + encodeURIComponent(this.state.name) : ""}${this.state.characteristicDescription ? "&description=" + encodeURIComponent(this.state.characteristicDescription) : ""}${this.state.selectedSpecificationId ? "&specId=" + this.state.selectedSpecificationId : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        if (res.data.length > 0) {
          var productCharacteristics = res.data.map(fromApi);
          this.setState({
            productCharacteristics: productCharacteristics,
            totalCharacteristicsCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
        //this.initializeCharacteristics();
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics:", err);
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(err.response.data.message, "error");
          } else {
            this.props.setErrorMessage(err.response.data.message, false);
          }
        } else {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              "error",
            );
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        }
      });
  };

  getSpecificSpecificationDetail = (specId) => {
    this.setState({ showLoading: true, showSpecLoading: true });
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productSpecifications/${specId}`,
      "",
    )
      .then((res) => {
        if (res.data) {
          this.setState({
            productSpecifications: [res.data],
            selectedSpecificationId: specId,
            selectedSpecificationDescription: res.data.name
              ? res.data.name
              : res.data.description,
            selectedSpecificationPath: specId.toString(),
          });
          if (!this.state.expandedNodes.includes(specId.toString())) {
            this.setState((prevState) => ({
              expandedNodes: [...prevState.expandedNodes, specId.toString()],
            }));
          }
          if (res.data.productSpecCharacteristic.length > 0) {
            var productCharacteristics =
              res.data.productSpecCharacteristic.map(fromApi);
            const filteredProductCharacteristics = productCharacteristics
              .filter((pc) =>
                this.state.selectedCharacteristics.some(
                  (sc) => sc.id === pc.id && sc.specId === pc.specId,
                ),
              )
              .map((pc) => {
                const matchedCharacteristic =
                  this.state.selectedCharacteristics.find(
                    (sc) => sc.id === pc.id && sc.specId === pc.specId,
                  );
                return {
                  ...pc,
                  value: matchedCharacteristic?.value || pc.value || "",
                  format: matchedCharacteristic?.format || pc.format || "",
                  characteristicValueSpecification:
                    matchedCharacteristic?.characteristicValueSpecification ||
                    pc.characteristicValueSpecification ||
                    [],
                };
              });
            this.setState({
              productCharacteristics: filteredProductCharacteristics.sort(
                (a, b) => a.name.localeCompare(b.name),
              ),
              totalCharacteristicsCount:
                res.data.productSpecCharacteristic.length,
            });
          } else {
            this.setState({
              productCharacteristics: [],
              totalCharacteristicsCount: 0,
            });
          }
        }
        this.setState({ showLoading: false, showSpecLoading: false });
      })
      .catch((err) => {
        console.error("Error fetching Product Specifications:", err);
        this.setState({ showLoading: false, showSpecLoading: false });
        //const errMsg = err?.response?.data?.message || this.props.t('DEFAULT_ERROR_MESSAGE');
        //this.props.setErrorMessage(errMsg, false);
        if (err.response && err.response.data && err.response.data.message) {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(err.response.data.message, "error");
          } else {
            this.props.setErrorMessage(err.response.data.message, false);
          }
        } else {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              "error",
            );
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        }
      });
  };

  handleNodeClick = (id, description, path) => {
    const pathString = path.join("-"); // Convert path array to string
    /*if(path[0] !== this.state.selectedSpecificationPath){
            this.setState({allUpdatedCharacteristics:[]})
        }*/
    if (path[0] !== this.state.selectedSpecificationPath.split("-")[0]) {
      this.setState({ allUpdatedCharacteristics: [] });
    }
    const pathArrayList = pathString ? pathString.split("-") : [];
    const rootSpecificationId =
      pathArrayList.length > 0 ? pathArrayList[0] : id;

    this.setState(
      {
        selectedSpecificationId: id,
        selectedSpecificationDescription: description,
        selectedSpecificationPath: pathString, // Store path for highlighting
        productCharacteristics: [],
        totalCharacteristicsCount: 0,
        rootSpecificationId: rootSpecificationId,
      },
      () => {
        if (!this.state.existingProductSpecification) {
          this.getCharacteristicList();
        } else {
          this.replaceCharacteristicsWithAppl();
        }
      },
    );
  };

  replaceCharacteristicsWithAppl = () => {
    this.setState({ showLoading: true });
    //console.log("---------------------replaceCharacteristicsWithAppl-----------------",this.state.selectedCharacteristics);
    let pageOptions = {
      batchSize: this.state.rowsPerPageCharacteristics,
      startRecord: this.state.startRecordCharacteristics,
    };

    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/productCharacteristics?sortBy=name&sortOrder=ASC` +
        `${this.state.name ? "&name=" + encodeURIComponent(this.state.name) : ""}` +
        `${this.state.characteristicDescription ? "&description=" + encodeURIComponent(this.state.characteristicDescription) : ""}` +
        `${this.state.selectedSpecificationId ? "&specId=" + this.state.selectedSpecificationId : ""}`,
      "",
      pageOptions,
    )
      .then((res) => {
        this.setState({ showLoading: false });
        //console.log("=========res====data===",res.data);
        if (res.data.length > 0) {
          var transformedCharacteristics = res.data.map(fromApi);
          //console.log("---------------------transformedCharacteristics-----------------",transformedCharacteristics);
          const filteredProductCharacteristics = transformedCharacteristics
            .filter((pc) =>
              this.state.selectedCharacteristics.some(
                (sc) => sc.id === pc.id && sc.specId === pc.specId,
              ),
            )
            .map((pc) => {
              const matchedCharacteristic =
                this.state.selectedCharacteristics.find(
                  (sc) => sc.id === pc.id && sc.specId === pc.specId,
                );
              //console.log("==========matchedCharacteristic=======",matchedCharacteristic);
              return {
                ...pc,
                value: matchedCharacteristic?.value || "",
                format: matchedCharacteristic?.format || "",
                characteristicValueSpecification:
                  matchedCharacteristic?.characteristicValueSpecification || [],
                //specId: matchedCharacteristic?.specId || '',
              };
            });
          this.setState({
            productCharacteristics: filteredProductCharacteristics,
            totalCharacteristicsCount: +res.headers["x-total-count"],
          });
        } else {
          this.setState({
            productCharacteristics: [],
            totalCharacteristicsCount: 0,
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching Product Characteristics:", err);
        this.setState({ showLoading: false });
        if (err.response && err.response.data && err.response.data.message) {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(err.response.data.message, "error");
          } else {
            this.props.setErrorMessage(err.response.data.message, false);
          }
        } else {
          if (this.props.showResponseMessage) {
            this.props.showResponseMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              "error",
            );
          } else {
            this.props.setErrorMessage(
              this.props.t("DEFAULT_ERROR_MESSAGE"),
              false,
            );
          }
        }
      });
  };

  handleExpand = (id, description, path) => {
    const pathString = path.join("-"); // Convert array to a string

    //this.handleNodeClick(id, description, path);

    this.setState((prevState) => ({
      expandedNodes: prevState.expandedNodes.includes(pathString)
        ? prevState.expandedNodes.filter((p) => p !== pathString)
        : [...prevState.expandedNodes, pathString],
    }));
  };

  validateFormat = (value, format) => {
    if (!format || !value || value === "-") return true;

    try {
      const regex = new RegExp(`^(${format})$`, "i");
      return regex.test(value);
    } catch (error) {
      //console.error("Invalid regex format:", format);
      return true; // Allow it if the regex is broken
    }
  };

  renderTreeItems = (nodes, path = []) => {
    return nodes.map((node) => {
      const currentPath = [...path, node.id];
      const pathString = currentPath.join("-"); // Convert path to string
      const isSelected = this.state.selectedSpecificationPath === pathString;
      return (
        <TreeItem
          key={pathString} // Ensure unique key as a string
          nodeId={pathString} // Ensure nodeId is a string
          className={isSelected ? "selectedNode" : ""} // Apply class
          label={
            <div style={{ display: "flex", alignItems: "center" }}>
              {node.productSpecificationRelationship &&
              node.productSpecificationRelationship.length > 0 ? (
                <>
                  <div
                    style={{ paddingRight: "5px" }}
                    className={`expandIconWrapper ${this.state.expandedNodes.includes(pathString) ? "isOpen" : ""}`}
                    onClick={() =>
                      this.handleExpand(node.id, node.name, currentPath)
                    }
                  >
                    <OpenItemIcon />
                  </div>
                  <div
                    onClick={() =>
                      this.handleNodeClick(node.id, node.name, currentPath)
                    }
                  >
                    {node.name || node.description}
                  </div>
                </>
              ) : (
                <>
                  <div
                    style={{ paddingRight: "5px" }}
                    className={`expandIconWrapper`}
                  >
                    <EndItemIcon />
                  </div>
                  <div
                    onClick={() =>
                      this.handleNodeClick(node.id, node.name, currentPath)
                    }
                  >
                    {node.name || node.description}
                  </div>
                </>
              )}
            </div>
          }
        >
          {node.productSpecificationRelationship &&
            node.productSpecificationRelationship.length > 0 &&
            this.renderTreeItems(
              node.productSpecificationRelationship,
              currentPath,
            )}
        </TreeItem>
      );
    });
  };

  TableSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <TableContainer>
        <Table
          className={`${classes.table} newGlobalTable`}
          aria-label="simple table"
        >
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "25%" }}>
                <b>{t("NAME")}</b>
              </TableCell>
              <TableCell style={{ width: "25%" }}>
                <b>{t("DESCRIPTION")}</b>
              </TableCell>
              <TableCell style={{ width: "25%" }}>
                <b>{t("VALIDATION_FORMAT")}</b>
              </TableCell>
              <TableCell style={{ width: "25%" }}>
                <b>{t("VALUE")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.productCharacteristics.map((row) => (
              <TableRow key={`${row.specId}_${row.id}`}>
                <TableCell>{row.name}</TableCell>
                <TableCell style={{ wordBreak: "break-all" }}>
                  {row.description || ""}
                </TableCell>
                <TableCell>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 10,
                    }}
                  >
                    <Input
                      size={"small"}
                      variant={"outlined"}
                      placeholder={t("VALIDATION_FORMAT")}
                      name="format"
                      divClass={classes.inputClass}
                      value={
                        this.state.formDataAddSpec[`${row.specId}_${row.id}`]
                          ?.format ??
                        row.format ??
                        ""
                      }
                      onChange={(e) =>
                        this.handleChangeAddSpec(
                          e,
                          row.id,
                          row.specId || "",
                          row?.valueType,
                          row.format || "",
                        )
                      }
                      disabled={
                        this.props.readonlyMode ||
                        !this.state.existingProductSpecification
                      }
                    />
                  </Grid>
                </TableCell>
                <TableCell>
                  <Grid
                    item
                    size={{
                      xs: 12,
                      md: 10,
                    }}
                  >
                    {(row?.valueType?.toUpperCase() === "STRING" ||
                      row?.valueType?.toUpperCase() === "OBJECT") && (
                      <>
                        <Input
                          size={"small"}
                          variant={"outlined"}
                          //placeholder={t('VALUE') + ' *'}
                          placeholder={t("VALUE")}
                          disabled={
                            this.props.readonlyMode ||
                            !this.state.existingProductSpecification
                          }
                          name="value"
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                          divClass={classes.inputClass}
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          onChange={(e) =>
                            this.handleChangeAddSpec(
                              e,
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            )
                          }
                          multiline={true}
                          onBlur={() => {
                            const value =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value || "";
                            const format = this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.hasOwnProperty("format")
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].format
                              : row.format || "";
                            if (format && value) {
                              try {
                                const regex = new RegExp(format);
                                if (!regex.test(value)) {
                                  this.setState((prevState) => ({
                                    formDataAddSpec: {
                                      ...prevState.formDataAddSpec,
                                      [`${row.specId}_${row.id}`]: {
                                        ...prevState.formDataAddSpec[
                                          `${row.specId}_${row.id}`
                                        ],
                                        value: "",
                                      },
                                    },
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]:
                                        `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                        format,
                                    },
                                  }));
                                } else {
                                  this.setState((prevState) => ({
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]: "",
                                    },
                                  }));
                                }
                              } catch (error) {
                                console.error("Invalid regex format:", format);
                              }
                            }
                          }}
                          fullWidth
                        />
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {row?.valueType?.toUpperCase() === "NUMBER" && (
                      <>
                        <Input
                          type="text"
                          inputProps={{ pattern: "[0-9]*" }}
                          size={"small"}
                          variant={"outlined"}
                          //placeholder={t('VALUE') + ' *'}
                          placeholder={t("VALUE")}
                          disabled={
                            this.props.readonlyMode ||
                            !this.state.existingProductSpecification
                          }
                          name="value"
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                          divClass={classes.inputClass}
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          onChange={(e) => {
                            const onlyNumbers = e.target.value.replace(
                              /[^0-9]/g,
                              "",
                            );
                            this.handleChangeAddSpec(
                              {
                                target: {
                                  name: e.target.name,
                                  value: onlyNumbers,
                                },
                              },
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            );
                          }}
                          onBlur={() => {
                            const value =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value || "";
                            //const format = this.state.formDataAddSpec[`${row.specId}_${row.id}`]?.format || row.format || '';
                            const format = this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.hasOwnProperty("format")
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].format
                              : row.format || "";
                            if (format && value) {
                              try {
                                const regex = new RegExp(format);
                                if (!regex.test(value)) {
                                  this.setState((prevState) => ({
                                    formDataAddSpec: {
                                      ...prevState.formDataAddSpec,
                                      [`${row.specId}_${row.id}`]: {
                                        ...prevState.formDataAddSpec[
                                          `${row.specId}_${row.id}`
                                        ],
                                        value: "",
                                      },
                                    },
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]:
                                        `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                        format,
                                    },
                                  }));
                                } else {
                                  this.setState((prevState) => ({
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]: "",
                                    },
                                  }));
                                }
                              } catch (error) {
                                console.error("Invalid regex format:", format);
                              }
                            } else {
                              this.setState((prevState) => ({
                                formDataAddSpec: {
                                  ...prevState.formDataAddSpec,
                                  [`${row.specId}_${row.id}`]: {
                                    ...prevState.formDataAddSpec[
                                      `${row.specId}_${row.id}`
                                    ],
                                    value: isNaN(value) ? "" : value,
                                  },
                                },
                                errors: {
                                  ...prevState.errors,
                                  [`${row.specId}_${row.id}`]: isNaN(value)
                                    ? "Value must be numeric."
                                    : "",
                                },
                              }));
                            }
                          }}
                          fullWidth
                        />
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {row?.valueType?.toUpperCase() === "DECIMAL" && (
                      <>
                        <Input
                          type="text"
                          size="small"
                          variant="outlined"
                          //placeholder={t('VALUE') + ' *'}
                          placeholder={t("VALUE")}
                          disabled={
                            this.props.readonlyMode ||
                            !this.state.existingProductSpecification
                          }
                          name="value"
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                          divClass={classes.inputClass}
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          onChange={(e) => {
                            const onlyDecimals = e.target.value.replace(
                              /[^0-9.]/g,
                              "",
                            ); // Allow numbers and dots
                            if (/^\d*\.?\d*$/.test(onlyDecimals)) {
                              // Ensure valid decimal format
                              this.handleChangeAddSpec(
                                {
                                  target: {
                                    name: e.target.name,
                                    value: onlyDecimals,
                                  },
                                },
                                row.id,
                                row.specId || "",
                                row?.valueType,
                                row.format || "",
                              );
                            }
                          }}
                          onBlur={() => {
                            const value =
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value || "";
                            //const format = this.state.formDataAddSpec[`${row.specId}_${row.id}`]?.format || row.format || '';
                            const format = this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.hasOwnProperty("format")
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].format
                              : row.format || "";
                            if (format && value) {
                              try {
                                const regex = new RegExp(format);
                                if (!regex.test(value)) {
                                  this.setState((prevState) => ({
                                    formDataAddSpec: {
                                      ...prevState.formDataAddSpec,
                                      [`${row.specId}_${row.id}`]: {
                                        ...prevState.formDataAddSpec[
                                          `${row.specId}_${row.id}`
                                        ],
                                        value: "",
                                      },
                                    },
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]:
                                        `${t("VALIDATION_FORMAT_MSG")}:- ` +
                                        format,
                                    },
                                  }));
                                } else {
                                  this.setState((prevState) => ({
                                    errors: {
                                      ...prevState.errors,
                                      [`${row.specId}_${row.id}`]: "",
                                    },
                                  }));
                                }
                              } catch (error) {
                                console.error("Invalid regex format:", format);
                              }
                            } else {
                              this.setState((prevState) => ({
                                formDataAddSpec: {
                                  ...prevState.formDataAddSpec,
                                  [`${row.specId}_${row.id}`]: {
                                    ...prevState.formDataAddSpec[
                                      `${row.specId}_${row.id}`
                                    ],
                                    value: isNaN(value) ? "" : value,
                                  },
                                },
                                errors: {
                                  ...prevState.errors,
                                  [`${row.specId}_${row.id}`]: isNaN(value)
                                    ? "Value must be numeric."
                                    : "",
                                },
                              }));
                            }
                          }}
                          fullWidth
                        />
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {row?.valueType?.toUpperCase() === "DATE" && (
                      <>
                        <FormControl
                          variant="outlined"
                          size="small"
                          fullWidth
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                        >
                          <InputLabel style={{ background: "#fff" }} shrink>
                            DD-MM-YYYY
                          </InputLabel>
                          <Input
                            type="date"
                            //size="small"
                            //variant="outlined"
                            //placeholder="YYYY-MM-DD"
                            //placeholder={t('VALUE') + ' *'}
                            //placeholder={t('VALUE')}
                            disabled={
                              this.props.readonlyMode ||
                              !this.state.existingProductSpecification
                            }
                            name="value"
                            divClass={classes.inputClass}
                            //error={!!this.state.errors[`${row.specId}_${row.id}`]}
                            value={
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value !== undefined
                                ? this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ].value
                                : row.value || ""
                            }
                            onChange={(e) =>
                              this.handleChangeAddSpec(
                                e,
                                row.id,
                                row.specId || "",
                                row?.valueType,
                                row.format || "",
                              )
                            }
                            onBlur={(e) => {
                              const value = e.target.value;
                              // Validate date format
                              if (!value) {
                                this.setState((prevState) => ({
                                  errors: {
                                    ...prevState.errors,
                                    value: "Please enter a valid date.",
                                  },
                                }));
                              } else {
                                this.setState((prevState) => ({
                                  errors: {
                                    ...prevState.errors,
                                    value: "",
                                  },
                                }));
                              }
                            }}
                            fullWidth
                          />
                        </FormControl>
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {row?.valueType?.toUpperCase() === "DATETIME" && (
                      <>
                        <FormControl
                          variant="outlined"
                          size="small"
                          fullWidth
                          error={!!this.state.errors[`${row.specId}_${row.id}`]}
                        >
                          <InputLabel style={{ background: "#fff" }} shrink>
                            DD-MM-YYYY HH:MM
                          </InputLabel>
                          <Input
                            type="datetime-local"
                            //size="small"
                            //variant="outlined"
                            //placeholder="YYYY-MM-DD HH:MM:SS"
                            //placeholder={t('VALUE') + ' *'}
                            //placeholder={t('VALUE')}
                            disabled={
                              this.props.readonlyMode ||
                              !this.state.existingProductSpecification
                            }
                            name="value"
                            divClass={classes.inputClass}
                            //error={!!this.state.errors[`${row.specId}_${row.id}`]}
                            /*value={
                                                    this.state.formDataAddSpec[`${row.specId}_${row.id}`]?.value !== undefined
                                                      ? this.state.formDataAddSpec[`${row.specId}_${row.id}`].value
                                                      : row.value || ''
                                                }*/
                            value={normalizeDateTime(
                              this.state.formDataAddSpec[
                                `${row.specId}_${row.id}`
                              ]?.value !== undefined
                                ? this.state.formDataAddSpec[
                                    `${row.specId}_${row.id}`
                                  ].value
                                : row.value || "",
                            )}
                            onChange={(e) =>
                              this.handleChangeAddSpec(
                                e,
                                row.id,
                                row.specId || "",
                                row?.valueType,
                                row.format || "",
                              )
                            }
                            onBlur={(e) => {
                              const value = e.target.value;
                              // Validate date format
                              if (!value) {
                                this.setState((prevState) => ({
                                  errors: {
                                    ...prevState.errors,
                                    value:
                                      "Please enter a valid date and time.",
                                  },
                                }));
                              } else {
                                this.setState((prevState) => ({
                                  errors: {
                                    ...prevState.errors,
                                    value: "",
                                  },
                                }));
                              }
                            }}
                            fullWidth
                          />
                        </FormControl>
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <div className="text-error" >
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </div>
                        )}
                      </>
                    )}

                    {(row?.valueType?.toUpperCase() === "ENUMERATION" ||
                      row?.valueType?.toUpperCase() === "ENUM") && (
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.customeSelectLabel}
                        error={!!this.state.errors[`${row.specId}_${row.id}`]}
                        fullWidth
                      >
                        <InputLabel
                          id={`enumSpecLabel_${row.specId}_${row.id}`}
                          style={{ background: "#fff" }}
                          shrink
                        >
                          {t("VALUE")}
                        </InputLabel>
                        <Select
                          size={"small"}
                          variant={"outlined"}
                          name="value"
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.characteristicValueSpecification?.find(
                                  (opt) => opt.isDefault,
                                )?.value ||
                                row.value ||
                                ""
                          }
                          native
                          label="VALUE"
                          disabled={
                            this.props.readonlyMode ||
                            !this.state.existingProductSpecification
                          }
                          labelId={`enumSpecLabel_${row.specId}_${row.id}`}
                          onChange={(e) =>
                            this.handleChangeAddSpec(
                              e,
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            )
                          }
                        >
                          <option value="-">Select</option>
                          {row.characteristicValueSpecification?.map(
                            (option) => (
                              <option key={option.id} value={option.value}>
                                {option.id} : {option.value}
                              </option>
                            ),
                          )}
                        </Select>
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <FormHelperText>
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </FormHelperText>
                        )}
                      </FormControl>
                    )}
                    {row?.valueType?.toUpperCase() === "BOOLEAN" && (
                      <FormControl
                        variant="outlined"
                        size="small"
                        className={classes.customeSelectLabel}
                        error={!!this.state.errors[`${row.specId}_${row.id}`]}
                        fullWidth
                      >
                        <InputLabel
                          id={`enumSpecLabel_${row.specId}_${row.id}`}
                          style={{ background: "#fff" }}
                          shrink
                        >
                          {t("VALUE")}
                        </InputLabel>
                        <Select
                          size={"small"}
                          variant={"outlined"}
                          name="value"
                          value={
                            this.state.formDataAddSpec[
                              `${row.specId}_${row.id}`
                            ]?.value !== undefined
                              ? this.state.formDataAddSpec[
                                  `${row.specId}_${row.id}`
                                ].value
                              : row.value || ""
                          }
                          native
                          label="VALUE"
                          disabled={
                            this.props.readonlyMode ||
                            !this.state.existingProductSpecification
                          }
                          labelId={`enumSpecLabel_${row.specId}_${row.id}`}
                          onChange={(e) =>
                            this.handleChangeAddSpec(
                              e,
                              row.id,
                              row.specId || "",
                              row?.valueType,
                              row.format || "",
                            )
                          }
                        >
                          <option value="-">Select</option>
                          <option value="true">True</option>
                          <option value="false">False</option>
                        </Select>
                        {this.state.errors[`${row.specId}_${row.id}`] && (
                          <FormHelperText>
                            {this.state.errors[`${row.specId}_${row.id}`]}
                          </FormHelperText>
                        )}
                      </FormControl>
                    )}
                    <span style={{ textTransform: "capitalize" }}>
                      {row?.valueType?.toUpperCase() === "ENUMERATION" ||
                      row?.valueType?.toUpperCase() === "ENUM"
                        ? "(Enum)"
                        : `(` + row?.valueType.toLowerCase() + `)`}
                    </span>
                  </Grid>
                </TableCell>
                {/*<TableCell>
                            <Tooltip title={`${t('SELECT')} ${row.name}`}>
                                <Checkbox
                                    color="primary"
                                    name={row.id}
                                    //checked={this.state.selectedCharacteristics.some(item => item.id === row.id)}
                                    checked={this.state.selectedCharacteristics.some(
                                        (char) => char.id === row.id && char.action !== "DELETE"
                                    )}
                                    onChange={(e) => this.handleCheckboxChange(e, row)}
                                />
                            </Tooltip>
                        </TableCell>*/}
              </TableRow>
            ))}
            {this.state.showLoading && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  {t("LOADING")}
                </TableCell>
              </TableRow>
            )}
            {!this.state.showLoading &&
              this.state.productCharacteristics.length === 0 && (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    {t("NO_CHARACTERISTIC_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  PaginationCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className="global-custom-pagination"
        style={{ background: "rgba(196, 196, 196, 0.2)" }}
      >
        <label style={{ float: "left", padding: "5px" }}>
          {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCharacteristicsCount)}
        </label>
        <label>
          {t("ROWS_PER_PAGE")}:
          <Select
            value={this.state.rowsPerPageCharacteristics}
            onChange={this.handleChangeRowsPerPageCharacteristics}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </label>
        <Pagination
          count={Math.ceil(
            this.state.totalCharacteristicsCount /
              this.state.rowsPerPageCharacteristics,
          )}
          onChange={this.handleChangePageCharacteristics}
          page={this.state.pageCharacteristics}
          showFirstButton
          showLastButton
        />
      </div>
    );
  };

  SearchSectionCharacteristic = () => {
    const { t } = this.props;
    return (
      <div
        className={classes.searchOuterDiv}
        style={{ padding: "1rem 0.5rem 0.5rem" }}
      >
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("NAME")}
            disabled={this.props.readonlyMode}
            value={this.state.name}
            name={"name"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div className={classes.searchInputDiv}>
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("DESCRIPTION")}
            disabled={this.props.readonlyMode}
            value={this.state.characteristicDescription}
            name={"characteristicDescription"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onCharacteristicSearchKeyDown}
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-start" }}>
          <Tooltip title={t("SEARCH")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.getCharacteristicList}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title={t("CLEAR")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.clearSearchCharacteristic}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
        </div>
      </div>
    );
  };

  onCharacteristicSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getCharacteristicList();
    }
  };

  handleChangePageCharacteristics = (event, newPage) => {
    this.setState(
      {
        pageCharacteristics: newPage,
        startRecordCharacteristics:
          this.state.rowsPerPageCharacteristics * (newPage - 1) + 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  handleChangeRowsPerPageCharacteristics = (event) => {
    this.setState(
      {
        pageCharacteristics: 1,
        rowsPerPageCharacteristics: event.target.value,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  clearSearchCharacteristic = () => {
    this.setState(
      {
        name: "",
        characteristicDescription: "",
        pageCharacteristics: 1,
        startRecordCharacteristics: 1,
      },
      () => {
        this.getCharacteristicList();
      },
    );
  };

  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  onChangeSpecSearchCate = (e) => {
    let fieldName = e.target.name;
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        if (fieldName == "specificationSearchCategory") {
          this.getSpecificationList();
        }
      },
    );
  };

  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.getSpecificationList();
    }
  };

  clearSearch = () => {
    this.setState(
      {
        specificationSearchString: "",
        selectedSpecificationId: "",
        rootSpecificationId: "",
        //specificationSearchCategory:"-",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getSpecificationList();
      },
    );
  };

  handleToggleExpandCollapse = () => {
    const getAllNodePaths = (nodes, path = []) => {
      let allPaths = [];
      nodes.forEach((node) => {
        const currentPath = [...path, node.id];
        const pathString = currentPath.join("-");
        allPaths.push(pathString);
        if (
          node.productSpecificationRelationship &&
          node.productSpecificationRelationship.length > 0
        ) {
          allPaths = allPaths.concat(
            getAllNodePaths(node.productSpecificationRelationship, currentPath),
          );
        }
      });
      return allPaths;
    };

    if (this.state.allExpanded) {
      this.setState({
        expandedNodes: [],
        allExpanded: false,
      });
    } else {
      const allNodePaths = getAllNodePaths(this.state.productSpecifications);
      this.setState({
        expandedNodes: allNodePaths,
        allExpanded: true,
      });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState(
      {
        selectedSpecificationId: "",
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getSpecificationList();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        selectedSpecificationId: "",
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getSpecificationList();
      },
    );
  };

  SearchSection = () => {
    const { t } = this.props;
    return (
      <Grid container spacing={1}>
        <Grid
          item
          size={{
            xs: 12,
          }}
        >
          <FormControl
            variant="outlined"
            size="small"
            className={classes.customeSelectLabel}
          >
            <InputLabel
              id="categoryLabel"
              style={{ background: "#fff" }}
              shrink
            >
              Category
            </InputLabel>
            <Select
              size="small"
              variant="outlined"
              name="specificationSearchCategory"
              value={this.state.specificationSearchCategory}
              native
              label="Category"
              labelId="categoryLabel"
              //                            disabled={this.props.readonlyMode}
              disabled={true}
              onKeyDown={this.onSearchKeyDown}
              onChange={this.onChangeSpecSearchCate}
            >
              <option value="-">Select</option>
              {this.state.specCategoryList.map((item) => (
                <option key={item.id} value={item.id}>
                  {this.decodeHtml(item.name)}
                </option>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid
          item
          style={{ display: "flex", flexWrap: "nowrap" }}
          size={{
            xs: 12,
          }}
        >
          <Input
            size={"small"}
            variant={"outlined"}
            placeholder={t("SEARCH_SPECIFICATION")}
            disabled={this.props.readonlyMode}
            value={this.state.specificationSearchString}
            name={"specificationSearchString"}
            onChange={this.onChange}
            divClass={classes.inputClass}
            onKeyDown={this.onSearchKeyDown}
          />
          &nbsp;
          <Tooltip title={t("SEARCH")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.getSpecificationList}
            >
              <SearchIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip title={t("CLEAR")}>
            <IconButton
              className="iconButtonSecondary"
              onClick={this.clearSearch}
            >
              <ClearIcon />
            </IconButton>
          </Tooltip>
          &nbsp;
          <Tooltip
            title={this.state.allExpanded ? t("COLLAPSE_ALL") : t("EXPAND_ALL")}
          >
            <IconButton
              className="iconButtonSecondary"
              onClick={this.handleToggleExpandCollapse}
            >
              <ExpandAll />
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>
    );
  };

  PaginationSpec = () => {
    const { t } = this.props;
    return (
      <div className="global-custom-pagination">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {t("TOTAL_RECORDS")}: {formatNumber(this.state.totalCount)}
          </label>
          <label>
            {t("ROWS_PER_PAGE")}:
            <Select
              value={this.state.rowsPerPage}
              onChange={this.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "1rem",
          }}
        >
          <Pagination
            count={Math.ceil(this.state.totalCount / this.state.rowsPerPage)}
            onChange={this.handleChangePage}
            page={this.state.page}
            showFirstButton
            showLastButton
          />
        </div>
      </div>
    );
  };

  render() {
    const { t, productId, productName, storeApplData } = this.props;
    this.state.selectedProductId = productId;
    //const treeData = this.buildTree(this.state.productSpecifications);
    return (
      <>
        {!this.state.showSpecLoading && (
          <div
            style={{
              borderRadius: "8px",
              border: "1px solid lightgrey",
              background: "white",
              marginBottom: "20px",
            }}
          >
            <Grid container spacing={0}>
              <Grid
                item
                style={{
                  borderRight: "1px solid lightgrey",
                  padding: "1rem",
                  minHeight: "440px",
                }}
                size={{
                  xs: 12,
                  md: 4,
                }}
              >
                {!this.state.existingProductSpecification && (
                  <>
                    {this.SearchSection()}
                    <Divider style={{ marginTop: "1rem" }} />
                  </>
                )}
                <SimpleTreeView
                  className="specificationNodeRoot specificationNodeRootTreeView"
                  expanded={this.state.expandedNodes}
                >
                  {this.renderTreeItems(this.state.productSpecifications)}
                  {!this.state.showLoading &&
                    this.state.productSpecifications.length === 0 && (
                      <div style={{ paddingTop: "12px", textAlign: "center" }}>
                        {t("NO_SPECIFICATION_FOUND")}
                      </div>
                    )}
                </SimpleTreeView>
                {this.state.totalCount > this.state.rowsPerPage && (
                  <>
                    <Divider style={{ marginTop: "1rem" }} />
                    {this.PaginationSpec()}
                  </>
                )}
              </Grid>
              <Grid
                item
                style={{
                  overflow: "hidden",
                  padding: "1rem",
                  minHeight: "440px",
                }}
                size={{
                  xs: 12,
                  md: 8,
                }}
              >
                <>
                  <Typography
                    variant="h6"
                    component="div"
                    style={{
                      marginBottom: "20px",
                      borderBottom: "1px solid lightgrey",
                      padding: "1rem",
                    }}
                  >
                    <Grid container spacing={0}>
                      <Grid
                        item
                        size={{
                          xs: 12,
                          md: 9,
                        }}
                      >
                        {this.state.selectedSpecificationDescription}{" "}
                        {t("PRODUCT_CHARACTERISTIC")}
                      </Grid>
                      <Grid
                        item
                        style={{ textAlign: "right" }}
                        size={{
                          xs: 12,
                          md: 3,
                        }}
                      >
                        {!this.props.readonlyMode &&
                          this.state.selectedSpecificationId &&
                          (!this.state.rootSpecificationId ||
                            this.state.selectedSpecificationId ===
                              this.state.rootSpecificationId) &&
                          (!this.state.existingProductSpecification ? (
                            <Button
                              onClick={() => this.handleAssignAll("add")}
                              color="primary"
                              disabled={this.state.isClicked}
                            >
                              Assign
                            </Button>
                          ) : (
                            <>
                              <Button
                                onClick={() => this.handleAssignAll("edit")}
                                color="primary"
                                disabled={this.state.isClicked}
                              >
                                Update
                              </Button>
                              &nbsp;
                              <Button
                                onClick={this.handleUnassignAll}
                                color="primary"
                                disabled={this.state.isClicked}
                              >
                                Unassign
                              </Button>
                            </>
                          ))}
                      </Grid>
                    </Grid>
                  </Typography>
                  {!this.state.showLoading &&
                    this.state.selectedSpecificationId && (
                      <Card
                        variant="outlined"
                        style={{ borderRadius: "8px", marginBottom: "20px" }}
                      >
                        <div className={classes.root}>
                          {!this.props.readonlyMode &&
                            this.SearchSectionCharacteristic()}
                          {this.TableSectionCharacteristic()}
                          {this.state.totalCharacteristicsCount >
                            this.state.rowsPerPageCharacteristics &&
                            this.PaginationCharacteristic()}
                        </div>
                      </Card>
                    )}
                  {/*<div style={{ marginBottom: '1rem',marginRight: '1rem', textAlign: 'right' }}>
                                    {!this.props.readonlyMode &&
                                        (!this.state.existingProductSpecification
                                            ? <Button onClick={this.handleAssignAll} color="primary" disabled={this.state.isClicked}>Assign</Button>
                                            : <Button onClick={this.handleUnassignAll} color="primary" disabled={this.state.isClicked}>Unassign</Button>
                                        )
                                    }
                                </div>*/}
                </>
              </Grid>
            </Grid>
          </div>
        )}
        <Loader loading={this.state.showLoading} />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    enabledModules: state.auth.enabledModules,
    permissions: state.auth.userPerms,
    tenantData: state.auth.tenantData,
    loggedInUserType: state.auth.userLoginType,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(EditSpecCharacteristicsAppl));
